<script setup>
import { onMounted, ref } from 'vue';
import { useFelixBagAuxStore, useGlobalStateStore } from '../../../store';

const felixBagAuxStore = useFelixBagAuxStore();
const globalStateStore = useGlobalStateStore();

const nota = ref(null)
const comentario = ref('')
const form = ref(null)


onMounted(() => {
  felixBagAuxStore.pauseAfter(1000)
});

async function submitAvaliacao(event) {
  const results = await event
  console.log("Results: ", results)
  if (results.valid) {

    globalStateStore.globalState.selectedData.viewedAvaliacaoPeriodica++
    felixBagAuxStore.saveEvent(`avaliacao_${globalStateStore.avaliacaoModal.tipoAvaliacao}_${globalStateStore.avaliacaoModal.porcentagem}_nota`, 'form_submit', nota.value)
    felixBagAuxStore.saveEvent(`avaliacao_${globalStateStore.avaliacaoModal.tipoAvaliacao}_${globalStateStore.avaliacaoModal.porcentagem}_comentario`, 'form_submit', comentario.value)

    globalStateStore.globalState.avaliacoes[globalStateStore.avaliacaoModal.tipoAvaliacao].push(globalStateStore.avaliacaoModal.porcentagem)
    globalStateStore.avaliacaoModal.isOpen = false;

    felixBagAuxStore.hideInteractive("avaliacao-periodica")
  }
}

function required(v) {
  if (v) return true

  return "Campo obrigatório"
}

function range(value) {
  if (value >= 0 && value <= 10) return true

  return 'A avaliação precisa ser entre 0 a 10'
}

</script>

<template>
  <div id="avaliacao-periodica">
    <div class="modal-background"></div>
    <div class="modal">
      <p class="modal-title">Avaliação de conteúdo</p>
      <img style="width: 90%; margin-left: 2%; margin-top: 2%;"
        src="//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/16d3dfa1-ba14-470f-8d1f-868105727002.svg"
        alt="">
      <v-form validate-on="submit lazy" v-model="form" @submit.prevent="submitAvaliacao">
        <p class="question">De 0 a 10, o quanto você gostou dos conteúdos da jornada que preparamos para você?*</p>
        <v-text-field :rules="[required, range]" max="10" type="number" v-model="nota" variant="outlined"
          density="compact" label="Dê uma nota de 0 a 10"></v-text-field>


        <p class="question">Gostaria de deixar algum comentário?</p>
        <v-textarea :rules="[required]" v-model="comentario" variant="outlined" rows="2" density="compact" no-resize
          label="Escreva seu comentário..."></v-textarea>

        <v-btn style="margin-top: 10%;" @click="submitAvaliacao" type="submit" color="#660099"
          width="100%">Enviar</v-btn>
      </v-form>

    </div>


  </div>
</template>

<style scoped>
#avaliacao-periodica {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  z-index: 10;
}

.modal-background {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  background-color: black;
  opacity: 0.4;
}

.modal {
  width: 90%;
  height: 87%;
  background-color: white;
  border-radius: 8px;
  position: absolute;
  top: 7.5%;
  left: 5%;
  font-size: 11px;
  text-align: start;
  padding: 0 7.5%;
}

.modal-title {
  font-size: 14px;
  font-weight: bold;
  margin-top: 12%;
  text-align: center;
}

.question {
  margin-bottom: 5px;
}

.modal .close {
  position: absolute !important;
  left: 80%;
  top: 3%;
}

.close img {
  width: 30px;
}
</style>
